var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"label":_vm.$t(_vm.label)},on:{"change":value => _vm.$emit('change', value)}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }